import { Attr } from './Attr';
export var Param;
(function (Param) {
    let Value;
    (function (Value) {
        let Type;
        (function (Type) {
            Type["Single"] = "SINGLE";
            Type["Multi"] = "MULTI";
        })(Type = Value.Type || (Value.Type = {}));
        function single(value) {
            return { value, type: "SINGLE" };
        }
        Value.single = single;
        function multi(values) {
            return { values, type: "MULTI" };
        }
        Value.multi = multi;
    })(Value = Param.Value || (Param.Value = {}));
    function make(formula, name, value) {
        const source = "PARAM";
        return { ...Attr.categorical(formula, name), value, source };
    }
    Param.make = make;
})(Param || (Param = {}));
